<template>
  <div class="ig-iframe-box">
    <iframe id="ig-iframe"
            scrolling="no"
            name="iframe"
            :style="{height:height}"
            :src="src"></iframe>
  </div>
</template>

<script>
/**
 * 
 */
export default {
  name: 'ig-iframe',
  props: {
    src: {
      type: String,
    },
    height: {
      type: String,
      default: () => '100vh'
    }
  },


  methods: {
  },
  mounted () {
    // let iframe = document.getElementById("ig-iframe")
    // let ifrmaeContent = iframe.contentWindow;
    // let contentHeight = ifrmaeContent.window.document.body.scrollHeight
    // iframe.style.height = contentHeight + 'px'
  }
}
</script>

<style lang="scss" scoped>
.ig-iframe-box {
  background-color: white;
}
#ig-iframe {
  border: none;
  width: 100%;
  // padding: 0 20px;
  // object-position: 100% 100%;
  // object-fit: fill;
}
</style>